import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { AppRoutes, AppRoutesAdditional, AppRouting } from 'src/pages/app';
import { useAppSelector } from '../redux';

export const useGTM = () => {
  const location = useLocation();

  const prevLocationRef = useRef<string | null>(null);

  const { email, phoneNumber } = useAppSelector((store) => store.model.customer.data);

  useEffect(() => {
    const pagePath = location.pathname;

    window.dataLayer = window.dataLayer || [];

    const previousPage = prevLocationRef.current || null;

    // Pronalaženje odgovarajućeg pageName
    const findPageName = (): { pageName: string | undefined, type?: 'Dopunsko osiguranje' | 'Dodatno osiguranje' } => {
      for (const route of AppRouting) {
        const match = matchPath(route.path, location.pathname);
        const isAdditional = location.pathname.includes('dodatno-zdravstveno-osiguranje');
        if (match) {
          return { pageName: route.pageName, type: isAdditional ? 'Dodatno osiguranje' : 'Dopunsko osiguranje' };
        }
      }
      return { pageName: '' };
    };

    const pageName = findPageName();

    window.dataLayer.push({
      event: 'virtualPageview',
      pageURL: pagePath,
      pageTitle: pageName.pageName,
      previousPage,
      trackingData: {
        category: 'Zdravstveno osiguranje',
        label: pageName.type,
      }
    });

    // Collapse the A/B `-b` base so the baseline and B offers pages fire the same priceCheck event.
    const normalizedPath = pagePath.replace('dopunsko-zdravstveno-osiguranje-b/', 'dopunsko-zdravstveno-osiguranje/');

    if (normalizedPath === AppRoutes.OFFERS.fullPath) {
      window.dataLayer.push({
        event: 'gtmt.priceCheck',
        trackingData: {
          category: 'Zdravstveno osiguranje',
          action: 'priceCheck',
          label: 'Dopunsko osiguranje',
          email,
          telephone: phoneNumber,
        },
      });
    }

    if (pagePath === AppRoutesAdditional.OFFERS_PREVIEW.fullPath) {
      window.dataLayer.push({
        event: 'gtmt.priceCheck',
        trackingData: {
          category: 'Zdravstveno osiguranje',
          action: 'priceCheck',
          label: 'Dodatno osiguranje',
          email,
          telephone: phoneNumber,
        },
      });
    }

    if (pagePath === AppRoutesAdditional.THANK_YOU.fullPath) {
      window.dataLayer.push({
        event: 'gtmt.priceCheck',
        trackingData: {
          category: 'Zdravstveno osiguranje',
          action: 'priceCheck',
          label: 'Dodatno osiguranje',
          email,
          telephone: phoneNumber,
        },
      });
    }

    if (pagePath.includes(AppRoutes.CHECKOUT_PAYMENT_SENT.fullPath)) {
      window.dataLayer.push({
        event: 'DZO_UplatnicaJednokratno'
      });
    }

    if (pagePath.includes(AppRoutesAdditional.CHECKOUT_PAYMENT_SENT.fullPath)) {
      window.dataLayer.push({
        event: 'DODATNO_UplatnicaJednokratno'
      });
    }

    if (pagePath.includes(AppRoutes.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath)) {
      window.dataLayer.push({
        event: 'DZO_UplatnicaNaRate'
      });
    }

    if (pagePath.includes(AppRoutesAdditional.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath)) {
      window.dataLayer.push({
        event: 'DODATNO_UplatnicaNaRate'
      });
    }

    // Update the previous page reference
    prevLocationRef.current = pagePath;
  }, [location]);
};
